var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.042 10a6.958 6.958 0 1 1 13.916 0 6.958 6.958 0 0 1-13.916 0M10 1.542a8.458 8.458 0 1 0 0 16.916 8.458 8.458 0 0 0 0-16.916m0 9.208a.75.75 0 0 1-.75-.75V5.417a.75.75 0 0 1 1.5 0V9.25h2.583a.75.75 0 0 1 0 1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgTime;